/**
 * @desc Enums for prompt system, used to classify prop types, ensuring correct modals are displayed
 * @summary Enums for user prompts modals
 * @external {@link https://github.com/bcgov/invasivesbc/wiki/User-Prompt-System }
 */
export enum PromptTypes {
  Confirmation,
  Date,
  ManualUtm,
  Number,
  Radio,
  Text
}
